import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

@inject('SiteStore') @observer
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { menuOpened: false, menuFixed: false, menuTopPosition: 0 };
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll(event) {
    this.scrollFromTop = document.body.scrollTop || document.body.parentNode.scrollTop;
    const { SiteStore } = this.props;
    //const scrollTop = SiteStore.isMobileResolution ? SiteStore.submenuTop-267 : 330;
    const scrollTop = SiteStore.isMobileResolution ? SiteStore.submenuTop-30 : 330;

    this.setState(({ menuFixed, menuTopPosition }) => {
      const newState = { menuFixed: this.scrollFromTop > scrollTop };
      if (newState.menuFixed)
        newState.menuTopPosition = !menuFixed ? this.scrollFromTop : menuTopPosition;
      else
        newState.menuTopPosition = 0;

      return newState;
    });
  }

  componentWillMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const menuProps = {
      onClick: () => {
        this.setState({ menuOpened: false });
        window.scrollTo(0, 0);
      }
    };

    const { menuOpened, menuFixed, menuTopPosition } = this.state;
    const { SiteStore } = this.props;
    const style = SiteStore.isMobileResolution ? { top: menuTopPosition } : {};

    return (
      <header className={menuFixed ? 'fixed' : ''} style={style}>
        <div className="Wrapper">

          <NavLink to="/" className="Logo"><img src={require("../img/logo.svg")}/></NavLink>

          <button className="btn-Menu" onClick={(e) => {
            e.preventDefault();
            this.setState({ menuOpened: true });
          }}>
            <img src={require("../img/ico-menu.svg")}/>
            <span> Menu </span>
          </button>
          <nav className={menuOpened ? 'menu-active' : ''}>

            <button className="btn-Fechar Hide-Desktop" onClick={(e) => {
              e.preventDefault();
              this.setState({ menuOpened: false });
            }}>
              <img src={require("../img/ico-fechar.svg")}/>
              <span> Fechar </span>
            </button>

            <NavLink { ...menuProps } to="/introducao"> Introdução <span> Como utilizar <br/> este guia </span> <hr/> </NavLink>
            <NavLink { ...menuProps } to="/Identidade"> Identidade <span> Essência, Inspiração, Valores, <br/> Atributos e Posicionamento </span> <hr/> </NavLink>
            <NavLink { ...menuProps } to="/ExpressaoVerbal"> Expressão Verbal <span> Discurso que inspira todas as formas <br/> de expressão da marca  </span> <hr/> </NavLink>
            <NavLink { ...menuProps } to="/ExpressaoVisual"> Expressão Visual <span> Sua forma de se expressar <br/> por meio de imagens, cores. </span> <hr/> </NavLink>
            <NavLink { ...menuProps } to="/Downloads"> Downloads <span> Baixe aqui, fontes, <br/> imagens, ícones. </span> <hr/> </NavLink>
          </nav>

        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js